// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__Zj-h4"};